<template>
  <div class="digital-service-section">
    <base-heading>{{ baseTitle }}</base-heading>
    <base-table :data="activatedPackages"
                :columns="columnDefinition"
                class="purchase-history-table">
      <template #deezerStatus="data">
        <a :href="data.cellData" target="_blank" rel="nofollow">{{ data.cellData }}</a>
      </template>
      <template #hboStatus="data">
        <v-popover class="digital-tooltip" popover-class="digital-service-popover" trigger="hover" :auto-hide="false" placement="top">
          <a href="#" @click.prevent="copyCode(data.cellData)">{{ data.cellData }}</a>
          <template slot="popover">
            <div class='digital-tooltip-description'>
              <div class='tooltip-content-wrapper'>
                <transition name='fade' mode='out-in'>
                  <img v-if='codeCopied' src='/assets/images/green_circle_checkmark.svg' alt=''
                       class='digital-success-icon' />
                </transition>
                {{ codeCopied ? $t('digitalServices.tooltipSuccessCodeCopy') : $t('digitalServices.tooltipCopyCodeText') }}
              </div>
            </div>
          </template>
        </v-popover>
      </template>
      <template #price='{rowData}'>
        <div class='table-price'>
          <span class='currency'>{{ getPrice(rowData).formattedValue }}</span>
          {{ getPrice(rowData).currency }}/{{ $t('digitalServices.monthly') }}
        </div>
      </template>
      <template #deactivationDate='{rowData}'>
        <template v-if='!rowData.deactivationButton'>
          {{ rowData.dateOfDeactivation || '-' }}
        </template>
        <base-button v-else variant='primary'
                     class='full-width-btn deactivation-btn'
                     size='small'
                     :disabled="disableActions"
                     @click='deactivate(rowData)'>
          {{ $t('common.deactivate') }}
        </base-button>
      </template>
      <p class='no-data' slot='no-content'>{{ $t('common.noData') }}</p>
    </base-table>
  </div>
</template>

<script>
import BaseTable from '@/components/base/table/base-table'
import { nbaColumns, serviceCommonColumns, siguranNetColumns } from './table-config'
import { copyText } from '@/utils/copyTextUtil'
import i18n from '@/i18n'

export default {
  name: 'purchase-history-table',
  data () {
    return {
      codeCopied: false
    }
  },
  props: {
    activatedPackages: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    service: {
      type: String,
      default: 'NBA'
    },
    disableActions: {
      type: Boolean,
      default: false
    }
  },
  components: { BaseTable },
  computed: {
    baseTitle () {
      switch (this.$props.service) {
        case 'NBA':
          return i18n.tc('digitalServices.purchaseTable.titleNba')
        case 'SIGURAN_NET':
          return i18n.tc('digitalServices.purchaseTable.titleSiguranNet')
        default:
          return i18n.tc('digitalServices.purchaseTable.titleCommon')
      }
    },
    columnDefinition () {
      if (this.$props.service === 'DEEZER' || this.$props.service === 'HBO') return Object.freeze(serviceCommonColumns(this.$props.service.toLowerCase()))
      else if (this.$props.service === 'SIGURAN_NET') return Object.freeze(siguranNetColumns)
      return Object.freeze(nbaColumns)
    }
  },
  methods: {
    copyCode (code) {
      copyText(code)
        .then(() => {
          this.codeCopied = true
        })
    },
    getPrice (price) {
      return {
        formattedValue: price?.actualPrice?.formattedValue || 0,
        currency: price?.actualPrice?.currencyIso?.toLowerCase() || ''
      }
    },
    deactivate (activatedContract) {
      this.$emit('deactivate', { ...activatedContract, active: true })
    }
  }
}
</script>

<style scoped lang="scss">
.digital-service-section {
  margin-top: 4rem;
}

.no-data {
  padding: 1.6rem;
  text-align: center;
  color: $dark-grey;
}

.purchase-history-table {
  margin-bottom: 2.4rem;

  .table-price {
    .currency {
      color: $mtel-red
    }
  }

  .deactivation-btn {
    min-width: 14rem;
    margin-left: 2rem;

    @media (map_get($breakpoints, md)) {
      margin-left: 0;
    }
  }
}
</style>
